import React from 'react'
import s from './PanelBase.module.scss'

const ReadOnlyOperatorsList = ({
  base,
  operators = [],
  operatorsFilter = '',
  setOperatorsFilter = () => {},
  loadOperatorsPage = () => {},
  operatorsPagination = {},
  title = 'Операторы',
}) => {
  const filtered = operators.filter(op => {
    const q = (operatorsFilter || '').toLowerCase()
    if (!q) return true
    const emp = op.employee_name || String(op.employee)
    return (emp && emp.toLowerCase().includes(q)) || (op.phone && String(op.phone).toLowerCase().includes(q))
  })

  return (
    <div className={s.subPanel}>
      <div className={s.subPanelTitle}>{title}</div>

      <div className={s.searchRow}>
        <input
          className={s.searchInput}
          placeholder="Поиск по оператору..."
          value={operatorsFilter || ''}
          onChange={(e) => setOperatorsFilter(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') loadOperatorsPage(base.id, 1, operatorsFilter || '') }}
        />
      </div>

      {filtered.length ? (
        <>
          <div className={s.tableWrap}>
            <div className={s.tableScroll}>
            <table className={s.table}>
              <thead>
                <tr>
                  <th>№</th>
                  <th>Сотрудник</th>
                  <th>Телефон</th>
                  <th>Доп. тел.</th>
                  <th>Создано</th>
                  <th>Статус</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((op, index) => (
                  <tr key={op.id}>
                    <td className={s.numCell}>{index + 1}</td>
                    <td style={{ fontWeight: 600, color: '#1e293b' }}>{op.employee_name || op.employee}</td>
                    <td>{op.employee_phone || '—'}</td>
                    <td>{op.phone || '—'}</td>
                    <td style={{ fontSize: 12, color: '#64748b' }}>{op.created_at}</td>
                    <td>
                      <span className={`${s.badge} ${op.is_active ? s.active : s.inactive}`}>
                        {op.is_active ? 'Активен' : 'Неактивен'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </div>

          {!operatorsFilter && operatorsPagination?.count > 0 && (
            <div className={s.pagination}>
              <button className={s.pageBtn} disabled={!operatorsPagination.previous} onClick={() => loadOperatorsPage(base.id, (operatorsPagination.page || 1) - 1)}>Пред.</button>
              <span>Стр. {operatorsPagination.page || 1} из {Math.ceil(operatorsPagination.count / 25)}</span>
              <button className={s.pageBtn} disabled={!operatorsPagination.next} onClick={() => loadOperatorsPage(base.id, (operatorsPagination.page || 1) + 1)}>След.</button>
            </div>
          )}
        </>
      ) : (
        <div className={s.empty}>Операторы не найдены</div>
      )}
    </div>
  )
}

export default ReadOnlyOperatorsList
